<template>
  <div>
    <form @submit.prevent="saveModifierPrice">
      <b-modal
        id="showModal"
        v-model="showModal"
        size="xl"
        no-close-on-backdrop
        no-close-on-esc
        @shown="reset"
      >
        <div slot="modal-header" class="w-100">
          <font-awesome-icon icon="bars" />
          <span class="pl-2">
            {{ input ? 'Edit' : 'Add' }} Modifier Price
          </span>
        </div>
        <div>
          <b-container fluid class="pt-4">
            <b-row class="mt-2">
              <b-col md="2">
                <label>Modifier Item Code</label>
              </b-col>
              <b-col md="3" :class="{'form-error': errors.first('modifierItemCode')}">
                <b-form-input
                  v-model="obj.modifierItemCode"
                  v-validate="'required|alpha_num'"
                  type="text"
                  name="modifierItemCode"
                />
                <small>{{ errors.first('modifierItemCode') }}</small>
              </b-col>
              <b-col md="1" />
              <b-col md="2">
                <label>Modifier Group Code</label>
              </b-col>
              <b-col md="3" :class="{'form-error': errors.first('modifierGroupCode')}">
                <b-form-input
                  v-model="obj.modifierGroupCode"
                  v-validate="'required|alpha_num'"
                  type="text"
                  name="modifierGroupCode"
                />
                <small>{{ errors.first('modifierGroupCode') }}</small>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col md="2">
                <label>Price Type</label>
              </b-col>
              <b-col md="3" :class="{'form-error': errors.first('priceType')}">
                <b-form-input
                  v-model="obj.priceType"
                  v-validate="'required|alpha_num'"
                  type="text"
                  name="priceType"
                />
                <small>{{ errors.first('priceType') }}</small>
              </b-col>
              <b-col md="1" />
              <b-col md="2">
                <label>Price</label>
              </b-col>
              <b-col md="3" :class="{'form-error': errors.first('price')}">
                <b-form-input
                  v-model.number="obj.price"
                  v-validate="'required|numeric'"
                  type="text"
                  name="price"
                />
                <small>{{ errors.first('price') }}</small>
              </b-col>
            </b-row>
          </b-container>
        </div>
        <div slot="modal-footer" class="w-100">
          <b-btn type="submit" variant="success">
            <font-awesome-icon icon="save" />
            {{ input ? 'Update' : 'Save' }} Data
          </b-btn>
          <b-btn class="float-right" variant="danger" @click="discardModal">
            <font-awesome-icon icon="times" />Discard
          </b-btn>
        </div>
      </b-modal>
    </form>
  </div>
</template>

<script>
import { getResponseToMTH } from '@/utils/helpers';
import constants from '@/utils/constants';

export default {
  props: {
    input: {
      type: null,
      default: null
    },
    showModal: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      obj: {}
    };
  },
  methods: {
    // add and update records
    saveModifierPrice() {
      this.$validator.validate().then(valid => {
        if (valid) {
          if (this.input === null) {
            this.$store
              .dispatch('CreateModifierPrice', this.obj)
              .then(response => {
                let res = getResponseToMTH(
                  response,
                  this.$swal,
                  'Record is created'
                );
                if (res) {
                  this.$emit('discard-modal', true);
                  this.reset();
                }
              })
              .catch(error => {
                this.$swal(
                  constants.SOMETHING_WROING,
                  error.response.data.message,
                  constants.STATUS_ERROR
                );
              });
          } else {
            this.$store
              .dispatch('UpdateModifierPrice', this.obj)
              .then(response => {
                let res = getResponseToMTH(
                  response,
                  this.$swal,
                  constants.RECORD_IS_UPDATED
                );
                if (res) {
                  this.$emit('discard-modal', true);
                  this.reset();
                }
              })
              .catch(error => {
                this.$swal(
                  constants.SOMETHING_WROING,
                  error.response.data.message,
                  constants.STATUS_ERROR
                );
              });
          }
        }
      });
    },
    discardModal() {
      this.reset();
      this.$emit('discard-modal');
    },

    // reset input fields
    reset() {
      if (this.input == null) {
        this.obj = {
          id: '',
          modifierItemCode: '',
          modifierGroupCode: '',
          priceType: '',
          price: 0.0
        };
      } else {
        this.obj = this.input;
      }
    }
  }
};
</script>
